<template>
    <Upload :before-upload="upFile" action="/">
        <slot>
            <a>{{btn_name || $t('upload')}}</a>
        </slot>
    </Upload>
</template>

<script>
    import 'iview/dist/styles/iview.css';
    import { Upload } from 'iview'
    const XLSX = require('xlsx');

    export default {
        name: "myExcelToJson",
        components:{
            Upload
        },
        props:{
            btn_name:{
                default: '',
                type: String
            },
            one_col:{
                default: true
            }
        },
        methods: {
            upFile: function (file) {
                var self = this;
                const reader = new FileReader();
                reader.onload = function(e) {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, {type: 'array'});
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, {header:1});
                    if(jsonData.length > 0){
                        jsonData.splice(0,1);
                        if(self.one_col){
                            var rows = [];
                            jsonData.forEach((item)=>{
                                rows.push(item[0]);
                            });
                            self.$emit('change',rows);
                        }
                        else{
                            self.$emit('change',jsonData);
                        }
                    }
                };
                reader.readAsArrayBuffer(file);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myExcelToJson.vue